import React, { Component } from 'react';
import { CardBody, Card, Label, Col, Button, Row, Input } from 'reactstrap'
import { connect } from 'react-redux';
import { Preloading } from '../../components/UI/Preloader/action';
import fileSaver from 'file-saver';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {
    kycUsageStatsRequest,
    kycUsageMeteringRequest,
    kycApiUsageStatsRequest
} from './action';
import {
    displayErrorMessage, displaySuccessMessage,} from '../../Corporate/my-portfolio/monitoring/charts/monitoring-util'
import { toast } from 'react-toastify';

class KycUsage extends Component {

    state = {
        usageStatsFromDate: null,
        meteringFromDate: null,
        usageStatsToDate: null,
        meteringToDate: null,
        kycUsageStatsFile: null,
        kycUsageMeteringResponse: null,
        kycApiusageStatsFromDate: null,
        kycApiusageStatsToDate: null,
        kycApiUsageStatsFile:null

    };

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        if (this.props.kycUsageStatsFile !== prevProps.kycUsageStatsFile) {
            this.props.preloading(false);
            if (this.props.kycUsageStatsFile.status === "SUCCESS") {
                let statusCode = this.props.kycUsageStatsFile.data['status'];
                if (statusCode === 200) {
                    const data = this.props.kycUsageStatsFile.data.data;
                    let blob = new Blob([data], { type: 'application/octet-stream' });
                    fileSaver.saveAs(blob, `${"Kyc_Usage_Stats"}_${moment().format("DD_MMM_YYYY")}.zip`)
                } else if (statusCode === 204) {
                    displayErrorMessage("No data available!!")
                }
            } else if (this.props.kycUsageStatsFile.status === "FAILURE") {
                let errorMessage = 'Please try again later!!'
                if(this.props.kycUsageStatsFile.data) {
                    //error message is coming as array buffer so converting it to json object
                    let errorObj = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(this.props.kycUsageStatsFile.data)))
                    if(errorObj && errorObj.message)
                        errorMessage = (errorObj.message)
                }
                displayErrorMessage(errorMessage)
            }
        }

        if (this.props.kycUsageMeteringResponse !== prevProps.kycUsageMeteringResponse) {
            this.props.preloading(false);
            if (this.props.kycUsageMeteringResponse.status === "SUCCESS") {
                let statusCode = this.props.kycUsageMeteringResponse.data['status'];
                if (statusCode === 200) {
                    const data = this.props.kycUsageMeteringResponse.data.data;
                    let blob = new Blob([data], { type: 'application/octet-stream' });
                    fileSaver.saveAs(blob, `${"Kyc_Metering_Report"}_${moment().format("DD_MMM_YYYY")}.zip`)
                } else if (statusCode === 204) {
                    displayErrorMessage("No crawler status data found!!");
                }
            } else if (this.props.kycUsageMeteringResponse.status === "FAILURE") {
                let errorMessage = 'Please try again later!!'
                if(this.props.kycUsageMeteringResponse.data) {
                    //error message is coming as array buffer so converting it to json object
                    let errorObj = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(this.props.kycUsageMeteringResponse.data)))
                    if(errorObj && errorObj.message)
                        errorMessage = (errorObj.message)
                }
                displayErrorMessage(errorMessage)
            }
        }

        //KYC API USAGE SUCCESS or  FAILURE Handle 
        if (this.props.kycApiUsageStatsFile !== prevProps.kycApiUsageStatsFile) {
            this.props.preloading(false);
            if (this.props.kycApiUsageStatsFile.status === "SUCCESS") {
                let statusCode = this.props.kycApiUsageStatsFile.data['status'];
                if (statusCode === 200) {
                    const data = this.props.kycApiUsageStatsFile.data.data;
                    let blob = new Blob([data], { type: 'application/octet-stream' });
                    fileSaver.saveAs(blob, `${"Kyc_Api_Usage_Stats"}_${moment().format("DD_MMM_YYYY")}.zip`)
                } else if (statusCode === 204) {
                    displayErrorMessage("No data available!!")
                }
            } else if (this.props.kycApiUsageStatsFile.status === "FAILURE") {
                let errorMessage = 'Please try again later!!'
                if(this.props.kycApiUsageStatsFile.data) {
                    //error message is coming as array buffer so converting it to json object
                    let errorObj = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(this.props.kycApiUsageStatsFile.data)))
                    if(errorObj && errorObj.message)
                        errorMessage = (errorObj.message)
                }
                displayErrorMessage(errorMessage)
            }
        }

    }

    downloadUsageStats = () => {
        this.props.preloading(true);
        this.props.kycUsageStatsRequest({
            fromDate: moment(this.state.usageStatsFromDate).format("YYYY-MM-DD"),
            toDate: moment(this.state.usageStatsToDate).format("YYYY-MM-DD"),
        })
    }

    downloadMeteringReport = () => {
        this.props.preloading(true);
        this.props.kycUsageMeteringRequest({
            fromDate: moment(this.state.meteringFromDate).format("YYYY-MM-DD"),
            toDate: moment(this.state.meteringToDate).format("YYYY-MM-DD"),
        })
    }

    handleUsageStatsFromDateChange = (date) => {
        this.setState({
            usageStatsFromDate: date,
        })
    }

    handleUsageStatsToDateChange = (date) => {
        this.setState({
            usageStatsToDate: date,
        })
    }

    handleMeteringFromDateChange = (date) => {
        this.setState({
            meteringFromDate: date,
        })
    }

    handleMeteringToDateChange = (date) => {
        this.setState({
            meteringToDate: date,
        })
    }

    handleKycApiUsageStatsFromDateChange = (date) => {
        this.setState({
            kycApiusageStatsFromDate: date,
        })
    }

    handleKycApiUsageStatsToDateChange = (date) => {
        this.setState({
            kycApiusageStatsToDate: date,
        })
    }

    downloadKycApiUsageStats = () => {
        this.props.preloading(true);
        this.props.kycApiUsageStatsRequest({
            fromDate: moment(this.state.kycApiusageStatsFromDate).format("YYYY-MM-DD"),
            toDate: moment(this.state.kycApiusageStatsToDate).format("YYYY-MM-DD"),
        })
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">KYC Usage Stats & Metering</h4>
                </div>
                <Card>
                    <CardBody >
                        <Label>KYC Usage Stats</Label>
                        <Row>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.usageStatsFromDate}
                                    onChange={this.handleUsageStatsFromDateChange}
                                    placeholderText="Enter from date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.usageStatsToDate}
                                    onChange={this.handleUsageStatsToDateChange}
                                    placeholderText="Enter to date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col>
                                <Button
                                    color="primary"
                                    disabled={!this.state.usageStatsFromDate || !this.state.usageStatsToDate}
                                    onClick={this.downloadUsageStats}>
                                    Download Usage Stats Report
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <br/>
                <Card>
                    <CardBody>
                    <Label>KYC Metering</Label>
                        <Row>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.meteringFromDate}
                                    onChange={this.handleMeteringFromDateChange}
                                    placeholderText="Enter from date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.meteringToDate}
                                    onChange={this.handleMeteringToDateChange}
                                    placeholderText="Enter to date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={moment()}
                                />
                            </Col>
                            <Col>
                                <Button
                                    color="primary"
                                    disabled={!this.state.meteringFromDate || !this.state.meteringToDate}
                                    onClick={this.downloadMeteringReport}>
                                    Download Metering Report
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <br/>
                <Card>
                    <CardBody >
                        <Label>KYC API Usage Stats</Label>
                        <Row>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.kycApiusageStatsFromDate}
                                    onChange={this.handleKycApiUsageStatsFromDateChange}
                                    placeholderText="Enter from date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={new Date()} // Set the maximum date to today
                                    minDate={moment().subtract(2, 'months').toDate()}
                                />
                            </Col>
                            <Col sm={6}>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.kycApiusageStatsToDate}
                                    onChange={this.handleKycApiUsageStatsToDateChange}
                                    placeholderText="Enter to date"
                                    dateFormat="dd-MM-YYYY"
                                    maxDate={new Date()} // Set the maximum date to today
                                    minDate={moment().subtract(2, 'months').toDate()}
                                />
                            </Col>
                            <Col>
                                <Button
                                    color="primary"
                                    disabled={!this.state.kycApiusageStatsFromDate || !this.state.kycApiusageStatsToDate}
                                    onClick={this.downloadKycApiUsageStats}>
                                    Download KYC API Usage Stats Report
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <br/>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    kycUsageStatsFile: state.kycUsageReducer.kycUsageStatsFile,
    kycUsageMeteringResponse: state.kycUsageReducer.kycUsageMeteringResponse,
    kycApiUsageStatsFile: state.kycUsageReducer.kycApiUsageStatsFile
})

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    kycUsageStatsRequest: (data) => { dispatch(kycUsageStatsRequest(data)) },
    kycUsageMeteringRequest: (data) => { dispatch(kycUsageMeteringRequest(data))},
    kycApiUsageStatsRequest: (data) => {dispatch(kycApiUsageStatsRequest(data))}
});


export default connect(mapStateToProps, mapDispatchToProps)(KycUsage);